import { render } from "./quizThumbsUpDownResponse.vue?vue&type=template&id=775f4494"
import script from "./quizThumbsUpDownResponse.vue?vue&type=script&lang=js"
export * from "./quizThumbsUpDownResponse.vue?vue&type=script&lang=js"

import "./quizThumbsUpDownResponse.vue?vue&type=style&index=0&id=775f4494&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__